import turfKinks from "@turf/kinks";

export default function kinks(feature1) {
    return turfKinks(feature1);
};
